import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c2e69366"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding-bottom": "10px"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "padding": "10px",
    "background": "#fff"
  }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  style: {
    "padding": "5px"
  }
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 2,
  class: "column",
  style: {
    "position": "relative",
    "margin-bottom": "2px",
    "margin": "0 15px"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "visibility": "hidden"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "12px",
    "padding": "0 0 5px 10px"
  }
};
const _hoisted_9 = {
  class: "chat-bubble"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  style: {
    "font-size": "12px",
    "padding": "0 0 5px 10px"
  }
};
const _hoisted_12 = {
  class: "chat-bubble"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  style: {
    "position": "relative"
  },
  ref: "questionContainer"
};
const _hoisted_15 = {
  key: 0,
  class: "column",
  style: {
    "width": "100%",
    "position": "relative",
    "margin-bottom": "2px"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "visibility": "hidden"
  }
};
const _hoisted_17 = {
  style: {
    "font-size": "12px",
    "padding": "0 0 5px 10px"
  }
};
const _hoisted_18 = {
  class: "chat-bubble"
};
const _hoisted_19 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  key: 0,
  class: "answers"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  style: {
    "font-size": "12px",
    "padding": "0 0 5px 10px"
  }
};
const _hoisted_24 = {
  class: "chat-bubble"
};
const _hoisted_25 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = {
  key: 0,
  class: "answers",
  style: {
    "max-width": "280px"
  }
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 1,
  class: "column",
  style: {
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_30 = {
  class: "answer-pos",
  style: {
    "visibility": "hidden"
  }
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = ["href"];
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = ["href"];
const _hoisted_35 = {
  key: 1
};
const _hoisted_36 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "position": "absolute",
    "top": "50%",
    "left": "50%",
    "transform": "translate(-50%, -50%)"
  }
};
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"spinner\" data-v-c2e69366><div class=\"rect1\" data-v-c2e69366></div><div class=\"rect2\" data-v-c2e69366></div><div class=\"rect3\" data-v-c2e69366></div><div class=\"rect4\" data-v-c2e69366></div></div>", 1);
const _hoisted_38 = [_hoisted_37];
const _hoisted_39 = {
  class: "answer",
  ref: "answer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_avatar = _resolveComponent("el-avatar");
  return _openBlock(), _createElementBlock("div", null, [$data.init ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "logic",
    style: _normalizeStyle({
      paddingBottom: $data.answerHeight + 'px'
    })
  }, [_createElementVNode("div", _hoisted_1, [$props.content.logic.content.customer_setting.TopPicture && $props.content.logic.content.customer_setting.TopPicture != '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.content.logic.content.customer_setting.TopPicture,
    alt: "",
    class: "w"
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), $props.content.logic.content.customer_setting.pathContent && $props.content.logic.content.customer_setting.pathContent != '' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    class: "ql-editor",
    innerHTML: $props.content.logic.content.customer_setting.pathContent
  }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), $props.content.logic.content.customer_setting.prologue && $props.content.logic.content.customer_setting.prologue != '' && $data.initYin ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_avatar, {
    style: {
      "min-width": "40px",
      "background": "#fff"
    },
    shape: "square",
    src: $props.content.logic.content.customer_setting.customer_service_avatar
  }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, _toDisplayString($props.content.logic.content.customer_setting.nickName), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "ql-editor",
    innerHTML: $props.content.logic.content.customer_setting.prologue
  }, null, 8, _hoisted_10)])])]), _createElementVNode("div", {
    style: {
      "display": "flex"
    },
    class: _normalizeClass(["animate-elementl", [$data.questionsAndAnswers.length == 0 ? '' : 'animate-endl']])
  }, [_createVNode(_component_el_avatar, {
    style: {
      "min-width": "40px",
      "background": "#fff"
    },
    shape: "square",
    src: $props.content.logic.content.customer_setting.customer_service_avatar
  }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, _toDisplayString($props.content.logic.content.customer_setting.nickName), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "ql-editor",
    innerHTML: $props.content.logic.content.customer_setting.prologue
  }, null, 8, _hoisted_13)])])], 2)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questionsAndAnswers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "chat",
      style: {
        "position": "relative"
      }
    }, [item.question_content ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_avatar, {
      style: {
        "min-width": "40px",
        "background": "#fff"
      },
      shape: "square",
      src: $props.content.logic.content.customer_setting.customer_service_avatar
    }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_17, _toDisplayString($props.content.logic.content.customer_setting.nickName), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
      class: "ql-editor",
      innerHTML: item.question_content
    }, null, 8, _hoisted_20)]), $data.wenIndex == index && $data.toBeAnswers.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toBeAnswers, (itemc, indexc) => {
      return _openBlock(), _createElementBlock("div", {
        key: indexc,
        class: "rounded",
        style: _normalizeStyle([{
          background: $props.content.buttomColor,
          color: $props.content.buttomTextColor,
          fontSize: $props.content.buttonSize + 'px'
          // borderRadius: content.buttonRadius + 'px',
        }, {
          "border-radius": "18px"
        }]),
        onClick: $event => $options.handleClickAnswer(itemc, index)
      }, _toDisplayString(itemc.answer_content), 13, _hoisted_22);
    }), 128))])) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
      style: {
        "display": "flex"
      },
      class: _normalizeClass([$data.wenIndex == index ? 'animate-elementl' : 'animate-endl'])
    }, [_createVNode(_component_el_avatar, {
      style: {
        "min-width": "40px",
        "background": "#fff"
      },
      shape: "square",
      src: $props.content.logic.content.customer_setting.customer_service_avatar
    }, null, 8, ["src"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_23, _toDisplayString($props.content.logic.content.customer_setting.nickName), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
      class: "ql-editor",
      innerHTML: item.question_content
    }, null, 8, _hoisted_26)]), $data.wenIndex == index && $data.toBeAnswers.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toBeAnswers, (itemc, indexc) => {
      return _openBlock(), _createElementBlock("div", {
        key: indexc,
        class: "rounded",
        style: _normalizeStyle([{
          background: $props.content.buttomColor,
          color: $props.content.buttomTextColor,
          fontSize: $props.content.buttonSize + 'px'
          // borderRadius: content.buttonRadius + 'px',
        }, {
          "border-radius": "18px"
        }]),
        onClick: $event => $options.handleClickAnswer(itemc, index)
      }, _toDisplayString(itemc.answer_content), 13, _hoisted_28);
    }), 128))])) : _createCommentVNode("", true)])])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
      class: "chat-bubble-answer",
      style: _normalizeStyle([{
        background: $props.content.logic.content.setStyle.buttomColor,
        color: $props.content.logic.content.setStyle.buttomTextColor,
        fontSize: $props.content.logic.content.setStyle.buttonSize + 'px'
      }, {
        "border-radius": "8px",
        "border-top-right-radius": "0 !important"
      }])
    }, [_createElementVNode("div", null, _toDisplayString(item.answer_content), 1), index == $data.questionsAndAnswers.length - 1 && $props.linkUrl != '' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("a", {
      href: $props.linkUrl,
      style: {
        "text-decoration": "none"
      }
    }, _toDisplayString(item.answer_content), 9, _hoisted_32)])) : _createCommentVNode("", true)], 4)]), _createElementVNode("div", {
      class: _normalizeClass(["answer-pos", [$data.wenIndex - 1 == index ? 'animate-elementr' : 'animate-endr']])
    }, [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "chat-bubble-answer",
      style: _normalizeStyle([{
        background: $props.content.logic.content.setStyle.buttomColor,
        color: $props.content.logic.content.setStyle.buttomTextColor,
        fontSize: $props.content.logic.content.setStyle.buttonSize + 'px'
      }, {
        "border-top-right-radius": "0 !important"
      }])
    }, [index == $data.questionsAndAnswers.length - 1 && $props.linkUrl != '' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("a", {
      href: $props.linkUrl,
      style: {
        "text-decoration": "none",
        "color": "#fff"
      }
    }, _toDisplayString(item.answer_content), 9, _hoisted_34)])) : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(item.answer_content), 1))], 4)])], 2)]))]);
  }), 128)), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38)) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_39, null, 512)], 4)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "deles", {}, undefined, true)]);
}